import ReactBeforeSliderComponent from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";
import * as React from 'react';
export default {
  ReactBeforeSliderComponent,
  React
};